const styles = {
  footer: {
    padding: '40px 20px',
    background: '#0a0a0a',
    textAlign: 'center',
  },
  text: {
    fontSize: '0.85rem',
    color: '#64748b',
  },
  link: {
    color: '#94a3b8',
    textDecoration: 'none',
  },
};

function Footer() {
  return (
    <footer style={styles.footer}>
      <p style={styles.text}>
        <a href="https://lidacourses.com" style={styles.link}>LidaCourses</a> - &copy; {new Date().getFullYear()} MooveTV. All rights reserved.
      </p>
    </footer>
  );
}

export default Footer;
